import { render, staticRenderFns } from "./ClinicalResult.vue?vue&type=template&id=ea519c68&"
import script from "./ClinicalResult.vue?vue&type=script&lang=js&"
export * from "./ClinicalResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports